import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  user: null,
  token: null,
  role: null, // 'customer', 'restaurant', 'admin'
};

const Login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      const userData = action.payload.user || action.payload;
      // Determine role from user data
      let role = "customer";
      if (userData?.is_admin === "1" || userData?.is_admin === true) {
        role = "admin";
      } else if (
        userData?.is_resturant === true ||
        userData?.is_resturant === "1" ||
        userData?.is_restaurant === true ||
        userData?.is_restaurant === "1"
      ) {
        role = "restaurant";
      }

      state = {
        ...state,
        loading: false,
        user: userData,
        token: action.payload.token || userData?.token,
        role: role,
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = {
        ...state,
        user: null,
        token: null,
        role: null,
      };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Login;
